<script lang="ts" context="module">
  import { getAppConfig } from '../../../../common/config/app-config';
  import { getJoodMembershipType, getStr, globalCurrencyTag } from '../../../../common/util';
  import { getJoodCardImageUrlNew } from '../../services/pdp-data-services';
</script>

<script lang="ts">
  export let vasPrice;
  export let joodType;
  export let oldVasPrice = null;
  export let vasLabel;
  export let vasName = '';
  export let isNoPlan = false;
  const titleObj = {
    VIP: 'extra.pdp.prime.gold.display.text',
    BASIC: 'extra.pdp.prime.blue.display.text',
    SMART: 'extra.pdp.prime.smart.display.text',
  };
  let vasTitle = 'extra.pdp.prime.gold.display.text';
  const joodCardImageUrl = getJoodCardImageUrlNew(getJoodMembershipType());

  const { benefitType = 'DISCOUNT' } = getAppConfig();
  $: if (joodType) {
    vasTitle = titleObj[joodType];
  }

  $: prices = pickPrices(vasPrice, oldVasPrice);
  $: joodLabelVisible = prices.discount > 0;

  function pickPrices(vasPrice, oldVasPrice) {
    const discount = vasPrice;
    const current = oldVasPrice - (discount || 0);
    const old = oldVasPrice;
    return {
      old,
      current,
      discount,
    };
  }
</script>

<section class="c_joodcart c_joodvas-subs-price">
  <div class="c_joodvas-subs-price-wrapper">
    <div class="c_vas-type">
      <span class="vas-label">
        {vasLabel}
      </span>
      {#if vasName?.length > 0 && !isNoPlan}
        <span class="vas-type-name">
          <strong>{vasName}</strong>
        </span>
      {/if}
    </div>
    <section class="c_joodvas-subs-details">
      {#if +prices.current > 0}
        {#if joodLabelVisible}
          <div class="c_joodvas-subs-label">{getStr(vasTitle)}</div>
        {/if}
        <section class="c_joodvas-price-details">
          {@html globalCurrencyTag}
          <span class="fw-bold">
            {prices.current}
          </span>
          {#if benefitType === 'DISCOUNT'}
            <img class="jood-card-image" src={joodCardImageUrl} alt="Jood Card" />
          {/if}
        </section>
      {/if}
      <!-- {#if +prices.discount > 0}
        <section class="c_joodvas-old-price-details">
          <span class="striked-off">{prices.old}</span>
          <strong class="orange-text">
            {@html getStr('extra.cart.saved.amt', [globalCurrencyTag, prices.discount])}
          </strong>
        </section>
      {/if} -->
    </section>
  </div>
</section>

<style lang="scss">
  .c_joodvas-subs-details {
    .c_joodvas-price-details {
      .jood-card-image {
        height: 16px !important;
        border-radius: 2px;
        box-shadow: 0px 4px 4px 0px #00000026;
      }
    }
  }
</style>
